import {atomWithStorage} from 'jotai/utils';
import {KodataStoresFilterTypes, KodataStoresQueryFilters} from '../enums';

export const kodataStoresFiltersAtom = atomWithStorage<
  Array<{key: KodataStoresQueryFilters; value: any}>
>('kodata/find-stores/filters', []);

export const kodataStoresSortAtom = atomWithStorage<{
  columnName: KodataStoresFilterTypes;
  ascending: boolean;
  sort: string;
}>('kodata/find-stores/sort', {
  columnName: KodataStoresFilterTypes.est3AverageSales,
  ascending: false,
  sort: `${KodataStoresFilterTypes.est3AverageSales.toUpperCase()}_DESC`,
});
